/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/military_school_dome': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M10 21h12v1H10z"/><path pid="1" d="M13 26l1.5-2 1.5 2v-6h-3zM10 6v13h12V6H10zm11 6h-9V8h9v4zM10 19h1v2h-1z"/><path pid="2" d="M12 10h9v1h-9zM8.5 32H0v-8.5h1V31h7.5zM14.27 31h3.462v1H14.27zM32 32h-8.5v-1H31v-7.5h1zM31 14.269h1v3.462h-1zM32 8.5h-1V1h-7.5V0H32zM14.269 0h3.462v1h-3.462zM1 8.5H0V0h8.5v1H1zM0 14.27h1v3.462H0z"/>'
  }
})
